(() => {
  function initWelcomeLauncher() {
  const button = document.querySelector('[data-funto-welcome]');
  if (!button || button.dataset.ready) return;
  window.funtoWelcomeCleanup?.();
  const controller = new AbortController();
  const signal = controller.signal;
  const dock = button.closest('[data-funto-welcome-dock]');
  if (!dock) return;
  const dismiss = dock.querySelector('[data-funto-welcome-dismiss]');
  const dismissKey = 'funto-welcome-dismissed-' + location.host;
  const dismissed = () => { try { return sessionStorage.getItem(dismissKey) === 'true'; } catch { return false; } };
  const section = document.getElementById('shopify-section-' + button.dataset.popupSection);
  if (!section) return;
  const modal = section.querySelector('.sign-up-popup-modal');
  const overlay = section.querySelector('.sign-up-popup-overlay');
  const success = section.querySelector('.success-popup-modal');
  if (!modal || !overlay || !dismiss) return;
  button.dataset.ready = 'true';
  const subscribedKey = 'promo-bar-subscribed-' + location.host;
  let queued = false, wasOpen = false;
  const observed = new WeakSet();
  const sized = new WeakSet();
  const subscribed = () => {
    try { return JSON.parse(localStorage.getItem(subscribedKey) || 'null')?.subscribed === true; }
    catch { return false; }
  };
  const visible = element => {
    const rect = element.getBoundingClientRect(), style = getComputedStyle(element);
    return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight &&
      style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
  };
  const observe = root => {
    if (observed.has(root)) return;
    observed.add(root);
    observer.observe(root, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-expanded', 'hidden'] });
  };
  const chatState = () => {
    const host = document.querySelector('shopify-chat');
    const state = { open: false, activator: null, nudge: null };
    if (!host) return state;
    const search = root => {
      observe(root);
      for (const element of root.querySelectorAll('*')) {
        if (element.matches('button[aria-label="Close chat"]') && visible(element)) state.open = true;
        if (element.matches('button[aria-label="Open chat"]') && visible(element)) {
          state.activator = element;
          state.nudge = element.closest('.activator-nudge');
        }
        if (element.shadowRoot) search(element.shadowRoot);
      }
    };
    search(host.shadowRoot || host);
    return state;
  };
  const observer = new MutationObserver(() => schedule());
  const resize = new ResizeObserver(() => schedule());
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function sync() {
    queued = false;
    const chat = chatState();
    const blocked = !!document.querySelector('cart-drawer.active, #Details-menu-drawer-container[open]') || chat.open;
    if ((subscribed() || blocked || dismissed()) && modal.classList.contains('popup-modal--active')) {
      modal.classList.remove('popup-modal--active');
      overlay.classList.remove('popup-overlay--active');
    }
    const open = modal.classList.contains('popup-modal--active');
    const keyboard = window.visualViewport && innerHeight - visualViewport.height > 150;
    let clearance = 12;
    document.querySelectorAll('sticky-atc').forEach(sticky => {
      if (!sized.has(sticky)) { resize.observe(sticky); sized.add(sticky); }
      if (visible(sticky)) clearance = Math.max(clearance, innerHeight - sticky.getBoundingClientRect().top + 12);
    });
    if (chat.activator && !sized.has(chat.activator)) { resize.observe(chat.activator); sized.add(chat.activator); }
    const chatHeight = chat.activator?.getBoundingClientRect().height || 0;
    const dockHeight = dock.getBoundingClientRect().height || parseFloat(getComputedStyle(button).width) || 70;
    if (chat.nudge) {
      const chatBottom = (clearance + Math.max(0, (dockHeight - chatHeight) / 2)).toFixed(2) + 'px';
      if (chat.nudge.style.bottom !== chatBottom) chat.nudge.style.bottom = chatBottom;
      if (chat.nudge.style.transition !== 'bottom 180ms ease') chat.nudge.style.transition = 'bottom 180ms ease';
    }
    const bottom = clearance;
    const offset = bottom.toFixed(2) + 'px';
    if (dock.style.getPropertyValue('--welcome-bottom') !== offset) dock.style.setProperty('--welcome-bottom', offset);
    // Keep the mobile product content clear of the floating offer launcher.
    // The welcome modal and its normal timer remain available.
    const productMain = document.querySelector('main .main-product-section')?.closest('main');
    const productContentVisible = matchMedia('(max-width: 1024px)').matches && productMain && visible(productMain);
    const hide = !!(blocked || open || success?.classList.contains('popup-modal--active') || subscribed() || dismissed() || keyboard || productContentVisible);
    if (button.hidden !== hide) button.hidden = hide;
    if (dock.hidden !== hide) dock.hidden = hide;
    const expanded = String(open);
    if (button.getAttribute('aria-expanded') !== expanded) button.setAttribute('aria-expanded', expanded);
    if (open && !wasOpen) requestAnimationFrame(() => modal.querySelector('button')?.focus({ preventScroll: true }));
    if (!open && wasOpen && !hide) button.focus({ preventScroll: true });
    wasOpen = open;
  }
  dismiss.addEventListener('click', () => {
    try { sessionStorage.setItem(dismissKey, 'true'); } catch {}
    dock.hidden = true;
    schedule();
  }, { signal });
  button.addEventListener('click', event => {
    event.stopPropagation();
    overlay.classList.add('popup-overlay--active');
    modal.classList.add('popup-modal--active');
    schedule();
  }, { signal });
  document.addEventListener('keydown', event => {
    if (!modal.classList.contains('popup-modal--active')) return;
    if (event.key === 'Escape') {
      modal.querySelector('.promp-popup__close-btn')?.click();
      schedule();
    }
    if (event.key !== 'Tab') return;
    const fields = Array.from(modal.querySelectorAll('button, input, a[href], [tabindex="0"]')).filter(visible);
    const first = fields[0], last = fields[fields.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  }, { signal });
  addEventListener('scroll', schedule, { passive: true, signal });
  addEventListener('resize', schedule, { passive: true, signal });
  addEventListener('storage', schedule, { signal });
  document.addEventListener('transitionend', schedule, { signal });
  window.visualViewport?.addEventListener('resize', schedule, { passive: true, signal });
  window.funtoWelcomeCleanup = () => { controller.abort(); observer.disconnect(); resize.disconnect(); };
  observe(document.body);
  sync();
  }
  window.funtoWelcomeInit = initWelcomeLauncher;
  if (!window.funtoWelcomeSectionListener) {
    document.addEventListener('shopify:section:load', () => window.funtoWelcomeInit());
    window.funtoWelcomeSectionListener = true;
  }
  initWelcomeLauncher();
})();

(() => {
  function initWelcomeSuccess() {
    const success = document.querySelector('[data-welcome-success]');
    if (!success || success.dataset.initialized) return;
    window.funtoWelcomeSuccessCleanup?.();
    const controller = new AbortController();
    const signal = controller.signal;
    success.dataset.initialized = 'true';
    const section = success.closest('.shopify-section');
    const updateViewport = () => {
      const height = Math.round(window.visualViewport?.height || window.innerHeight) + 'px';
      if (section.style.getPropertyValue('--welcome-viewport-height') !== height) section.style.setProperty('--welcome-viewport-height', height);
    };
    updateViewport();
    window.addEventListener('resize', updateViewport, {passive:true, signal});
    window.visualViewport?.addEventListener('resize', updateViewport, {passive:true, signal});
    const overlay = section.querySelector('.success-popup-overlay');
    const signup = section.querySelector('.sign-up-popup-modal');
    const signupOverlay = section.querySelector('.sign-up-popup-overlay');
    const status = success.querySelector('[data-welcome-status]');
    const isOpen = () => success.classList.contains('popup-modal--active');
    let previousOverflow = document.body.style.overflow;
    const close = () => {
      success.classList.remove('popup-modal--active');
      overlay.classList.remove('popup-overlay--active');
      document.body.style.overflow = previousOverflow;
      document.querySelector('#MainContent a[href]')?.focus({preventScroll:true});
    };
    success.querySelector('[data-welcome-success-close]').addEventListener('click', close, {signal});
    overlay.addEventListener('click', close, {signal});
    success.querySelector('[data-welcome-copy]').addEventListener('click', async () => {
      const copyStatus = success.querySelector('[data-welcome-copy-status]');
      try {
        await navigator.clipboard.writeText(success.dataset.code);
        copyStatus.textContent = success.dataset.copyDone;
        success.querySelector('[data-welcome-copy]').textContent = success.dataset.copyDone;
      } catch {
        copyStatus.textContent = success.dataset.code;
      }
    }, {signal});
    document.addEventListener('keydown', event => {
      if (!isOpen()) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const targets = [...success.querySelectorAll('button, a[href]')].filter(el => el.getClientRects().length);
      const first = targets[0], last = targets.at(-1);
      if (event.shiftKey && (document.activeElement === first || !success.contains(document.activeElement))) {event.preventDefault();last?.focus();}
      else if (!event.shiftKey && (document.activeElement === last || !success.contains(document.activeElement))) {event.preventDefault();first?.focus();}
    }, {signal});
    const observer = new MutationObserver(() => {
      if (isOpen()) {
        if (signup?.classList.contains('popup-modal--active')) signup.classList.remove('popup-modal--active');
        if (signupOverlay?.classList.contains('popup-overlay--active')) signupOverlay.classList.remove('popup-overlay--active');
      }
    });
    if (signup) observer.observe(signup, {attributes:true, attributeFilter:['class']});
    async function applyWelcomeOffer() {
      const code = success.dataset.code;
      if (!code) return;
      status.textContent = success.dataset.applying;
      const requestController = new AbortController();
      const timeout = setTimeout(() => requestController.abort(), 6000);
      try {
        const options = {credentials:'same-origin', signal:requestController.signal, headers:{Accept:'application/json'}};
        const cartResponse = await fetch(success.dataset.root + 'cart.js', options);
        if (!cartResponse.ok) throw new Error('cart');
        const cart = await cartResponse.json();
        const current = (cart.discount_codes || []).filter(entry => entry.applicable).map(entry => entry.code);
        if (current.some(entry => entry.toLowerCase() === code.toLowerCase())) {status.textContent = success.dataset.applied;return;}
        if (current.length) {status.textContent = success.dataset.ready;return;}
        const response = await fetch(success.dataset.root + 'cart/update.js', {...options,method:'POST',headers:{...options.headers,'Content-Type':'application/json'},body:JSON.stringify({discount:code})});
        if (!response.ok) throw new Error('discount');
        const updated = await response.json();
        const applied = (updated.discount_codes || []).some(entry => entry.code.toLowerCase() === code.toLowerCase() && entry.applicable);
        status.textContent = applied ? success.dataset.applied : success.dataset.ready;
      } catch {
        status.textContent = success.dataset.ready;
      } finally { clearTimeout(timeout); }
    }
    document.addEventListener('shopify:block:select', event => {
      if (!success.contains(event.target)) return;
      success.classList.add('popup-modal--active');
      overlay.classList.add('popup-overlay--active');
      signup?.classList.remove('popup-modal--active');
      signupOverlay?.classList.remove('popup-overlay--active');
      document.body.style.overflow = 'hidden';
    }, {signal});
    if (isOpen()) {
      signup?.classList.remove('popup-modal--active');
      signupOverlay?.classList.remove('popup-overlay--active');
      document.body.style.overflow = 'hidden';
      requestAnimationFrame(() => success.querySelector('[data-welcome-success-close]').focus({preventScroll:true}));
      if (success.dataset.submitted === 'true' && success.dataset.preview !== 'true') {
        try {localStorage.setItem('promo-bar-subscribed-' + location.host,JSON.stringify({subscribed:true}));} catch {}
        applyWelcomeOffer();
      }
    }
    window.funtoWelcomeSuccessCleanup = () => {controller.abort();observer.disconnect();if(isOpen()) document.body.style.overflow = previousOverflow;};
  }
  document.addEventListener('shopify:section:load',initWelcomeSuccess);
  initWelcomeSuccess();
})();
